import preOrderAPI from '../../api/PreOrders'
import * as types from '../mutation-types'

// STATE
const state = {
    PreOrders: [],
    PreOrdersForecasted: [],
    PreOrdersForecastedPagination: {},
    ClosedPreOrders: [],
    PreOrder: {},
    PreOrderTotals: {},
    PreOrderNotifications: [],
    PreOrderProducts: {},
    PreOrderMarketingProducts: {},
    Customer: {},
    Customers: [],
    CustomersPagination: {},
    CustomersFilters: {},
    CustomerOptions: [],
    CustomerUsersOptions: [],
    CustomerAddressOptions: [],
    CustomerListOptions: {
        searchTerm: '',
        myCustomersOnly: true
    },
    PreOrdersFilters: {},
    PreOrdersPagination: {},
    PreOrderSubGroupTotals: {},
    PreOrderDeliveryMomentTotals: {},
    PreOrderTargetsAndTotals: {},
    AXWarnings: [],
    AXWarningsPagination: {}
}

// GETTERS
const getters = {
    PreOrders: state => state.PreOrders,
    PreOrdersFilters: state => state.PreOrdersFilters,
    PreOrdersPagination: state => state.PreOrdersPagination,
    PreOrdersForecasted: state => state.PreOrdersForecasted,
    PreOrdersForecastedPagination: state => state.PreOrdersForecastedPagination,
    ClosedPreOrders: state => state.ClosedPreOrders,
    PreOrder: state => state.PreOrder,
    PreOrderTotals: state => state.PreOrderTotals,
    PreOrderNotifications: state => state.PreOrderNotifications,
    PreOrderProducts: state => state.PreOrderProducts,
    PreOrderMarketingProducts: state => state.PreOrderMarketingProducts,
    Customer: state => state.Customer,
    Customers: state => state.Customers,
    CustomersPagination: state => state.CustomersPagination,
    CustomersFilters: state => state.CustomersFilters,
    CustomerOptions: state => state.CustomerOptions,
    CustomerUsersOptions: state => state.CustomerUsersOptions,
    CustomerAddressOptions: state => state.CustomerAddressOptions,
    CustomerListOptions: state => state.CustomerListOptions,
    PreOrderSubGroupTotals: state => state.PreOrderSubGroupTotals,
    PreOrderDeliveryMomentTotals: state => state.PreOrderDeliveryMomentTotals,
    PreOrderTargetsAndTotals: state => state.PreOrderTargetsAndTotals,
    AXWarnings: state => state.AXWarnings,
    AXWarningsPagination: state => state.AXWarningsPagination
}

// ACTIONS
const actions = {
    // PREORDERSHEET LIST
    createPreOrder({ commit }, params) {
        return new Promise((resolve, reject) => {
            preOrderAPI.createPreOrder(newSheetId => {
                commit(types.SEND_NEW_PREORDER, { newSheetId })
                resolve(newSheetId)
            }, params)
        })
    },
    getPreOrders({ commit }, params) {
        return new Promise((resolve, reject) => {
            preOrderAPI.getPreOrders(order => {
                commit(types.RECEIVE_PREORDERS, { order })
                resolve()
            }, params)
        })
    },
    getPreOrderById({ commit }, id) {
        return new Promise((resolve, reject) => {
            preOrderAPI.getPreOrderById(order => {
                commit(types.RECEIVE_PREORDER_BY_ID, { order })
                resolve()
            }, id)
        })
    },
    getPreOrderTotalsById({ commit }, id) {
      return new Promise((resolve, reject) => {
        preOrderAPI.getPreOrderTotalsById(order => {
          commit(types.RECEIVE_PREORDER_TOTALS_BY_ID, { order })
          resolve()
        }, id)
      })
    },
    getPreOrderNotificationsById({ commit }, id) {
      return new Promise((resolve, reject) => {
        preOrderAPI.getPreOrderNotificationsById(order => {
          commit(types.RECEIVE_PREORDER_NOTIFICATIONS_BY_ID, { order })
          resolve()
        }, id)
      })
    },
    getPreOrderProductsById({ commit }, params) {
      return new Promise((resolve, reject) => {
        preOrderAPI.getPreOrderProductsById(order => {
          commit(types.RECEIVE_PREORDER_PRODUCTS_BY_ID, { order })
          resolve()
        }, params)
      })
    },
    getPreOrderMarketingProductsById({ commit }, params) {
      return new Promise((resolve, reject) => {
        preOrderAPI.getPreOrderMarketingProductsById(order => {
          commit(types.RECEIVE_PREORDER_MARKETING_PRODUCTS_BY_ID, { order })
          resolve()
        }, params)
      })
    },
    updatePreOrderCustomer({ commit }, params) {
        return new Promise((resolve, reject) => {
            preOrderAPI.updatePreOrderCustomer(order => {
                if (order.status > 300) {
                    reject(order.data);
                } else {
                    resolve()
                    commit(types.UPDATE_PREORDER_BY_ID, { order })
                }
            }, params)
        })
    },
    updatePreOrderSalesman({ commit }, params) {
        return new Promise((resolve, reject) => {
            preOrderAPI.updatePreOrderSalesman(order => {
                if (order.status > 300) {
                    reject(order.data);
                } else {
                    resolve()
                    commit(types.UPDATE_PREORDER_BY_ID, { order })
                }
            }, params)
        })
    },
    closePreOrderById({ commit }, params) {
        return new Promise((resolve, reject) => {
            preOrderAPI.closePreOrderById(order => {
                resolve(order)
            }, params)
        })
    },

    resetPreOrder({ commit }) {
        commit(types.RESET_PREORDER)
    },

    // FORECASTED
    getPreOrdersForecasted({ commit }, params) {
        return new Promise((resolve, reject) => {
            preOrderAPI.getPreOrdersForecasted(order => {
                commit(types.RECEIVE_PREORDERS_FORECASTED, { order })
                resolve()
            }, params)
        })
    },

    // CLOSED PRE-ORDERS
    getClosedPreOrders({ commit }, params) {
        return new Promise((resolve, reject) => {
            preOrderAPI.getClosedPreOrders(order => {
                commit(types.RECEIVE_CLOSED_PREORDERS, { order })
                resolve()
            }, params)
        })
    },

    // NOTIFICATIONS
    updatePreOrderNotification({ commit }, params) {
        return new Promise((resolve, reject) => {
            preOrderAPI.updatePreOrderNotification(notification => {
                resolve(notification)
            }, params)
        })
    },

    // PRODUCT GROUP
    updatePreOrderGroup({ commit }, params) {
        return new Promise((resolve, reject) => {
            preOrderAPI.updatePreOrderGroup(group => {
                resolve(group)
            }, params)
        })
    },

    // PRODUCT
    updatePreOrderProduct({ commit }, params) {
        return new Promise((resolve, reject) => {
            preOrderAPI.updatePreOrderProduct(group => {
                resolve(group)
            }, params)
        })
    },

    // PRODUCT VARIANT
    updatePreOrderProductVariant({ commit }, params) {
        return new Promise((resolve, reject) => {
            preOrderAPI.updatePreOrderProductVariant(group => {
                resolve(group)
            }, params)
        })
    },

    // CUSTOMERS

    /**
     * @param params.searchTerm :: String
     * @param params.MyCustomersOnly :: Boolean
     */
    getCustomers({ commit }, params) {
        return new Promise((resolve, reject) => {
            preOrderAPI.getCustomers(customers => {
                commit(types.SEND_CUSTOMERS, { customers })
                resolve(customers)
            }, params)
        })
    },
    resetCustomers({ commit }) {
        commit(types.RESET_CUSTOMERS)
    },

    getCustomerById({ commit }, id) {
        return new Promise((resolve) => {
            preOrderAPI.getCustomerById(customer => {
                commit(types.RECEIVE_CUSTOMER_BY_ID, { customer })
                resolve()
            }, id)
        })
    },
    updateCustomerById({ commit }, params) {
        return new Promise((resolve) => {
            preOrderAPI.updateCustomerById(customer => {
                commit(types.SEND_CUSTOMER_BY_ID, { customer })
                resolve()
            }, params)
        })
    },
    blockCustomerUser({ commit }, params) {
        return new Promise((resolve) => {
            preOrderAPI.blockCustomerUser(customer => {
                resolve()
            }, params)
        })
    },

    getCustomerOptions({ commit }, params) {
        return new Promise((resolve) => {
            preOrderAPI.getCustomerSearch(customers => {
                commit(types.SEND_CUSTOMER_SEARCH, { customers })
                resolve(customers)
            }, params)
        })
    },
    getCustomerUsersOptions({ commit }, id) {
        return new Promise((resolve) => {
            preOrderAPI.getCustomerUsers(customerUsers => {
                commit(types.SEND_CUSTOMER_USERS, { customerUsers })
                resolve()
            }, id)
        })
    },
    getCustomerAddressOptions({ commit }, id) {
        return new Promise((resolve) => {
            preOrderAPI.getCustomerAddress(customerAddress => {
                commit(types.SEND_CUSTOMER_ADDRESS, { customerAddress })
                resolve(customerAddress)
            }, id)
        })
    },
    addCustomerUser({ commit }, params) {
        return new Promise((resolve, reject) => {
            preOrderAPI.addCustomerUser(user => {
                resolve(user)                
            }, params)
        })
    },

    // MARKETING PRODUCT GROUP
    updatePreOrderMarketingGroup({ commit }, params) {
        return new Promise((resolve, reject) => {
            preOrderAPI.updatePreOrderMarketingGroup(group => {
                resolve(group)
            }, params)
        })
    },

    // MARKETING PRODUCT
    updatePreOrderMarketingProduct({ commit }, params) {
        return new Promise((resolve, reject) => {
            preOrderAPI.updatePreOrderMarketingProduct(group => {
                resolve(group)
            }, params)
        })
    },

    // MARKETING PRODUCT VARIANT
    updatePreOrderMarketingProductVariant({ commit }, params) {
        return new Promise((resolve, reject) => {
            preOrderAPI.updatePreOrderMarketingProductVariant(group => {
                resolve(group)
            }, params)
        })
    },

    // SUBGROUP TOTALS
    getPreOrderSubGroupTotals({ commit }, id) {
        return new Promise((resolve, reject) => {
            preOrderAPI.getPreOrderSubGroupTotals(totals => {
                commit(types.RECEIVE_PREORDER_SUBGROUP_TOTALS, { totals })
                resolve()
            }, id)
        })
    },

    // DELIVERY MOMENT TOTALS
    getPreOrderDeliveryMomentTotals({ commit }, id) {
        return new Promise((resolve, reject) => {
            preOrderAPI.getPreOrderDeliveryMomentTotals(totals => {
                commit(types.RECEIVE_PREORDER_DELIVERY_MOMENT_TOTALS, { totals })
                resolve()
            }, id)
        })
    },

    // TARGETS AND TOTALS
    getPreOrderTargetsAndTotals({ commit }, id) {
        return new Promise((resolve, reject) => {
            preOrderAPI.getPreOrderTargetsAndTotals(totals => {
                commit(types.RECEIVE_PREORDER_TARGETS_AND_TOTALS, { totals })
                resolve()
            }, id)
        })
    },

    // SEND REMINDERS
    sendRemindersPreOrderById({ commit }, params) {
        return new Promise((resolve, reject) => {
            preOrderAPI.sendRemindersPreOrderById(reminders => {
                resolve(reminders)
            }, params)
        })
    },

    // SEND TO SALES
    sendToSales({ commit }, id) {
        return new Promise((resolve, reject) => {
            preOrderAPI.sendToSales(preorder => {
                commit(types.SEND_TO_SALES, { preorder })
                resolve()
            }, id)
        })
    },

    //AX WARNINGS
    getAXWarnings({ commit }, params) {
        return new Promise((resolve, reject) => {
            preOrderAPI.getAXWarnings(warnings => {
                commit(types.RECEIVE_AX_WARNINGS, { warnings })
                resolve()
            }, params)
        })
    },

    ignoreAXWarning({ commit }, id) {
        return new Promise((resolve, reject) => {
            preOrderAPI.ignoreAXWarning(warning => {
                commit(types.IGNORE_AX_WARNING, { warning })
                resolve()
            }, id)
        })
    },

    exportToCSV({ commit }, id) {
        return new Promise((resolve, reject) => {
            preOrderAPI.exportToCSV(csv => {
                resolve(csv)
            }, id)
        })
    },

    exportPreOrderToCSV({ commit }, id) {
        return new Promise((resolve, reject) => {
            preOrderAPI.exportPreOrderToCSV(csv => {
                resolve(csv)
            }, id)
        })
    },

    resendToAX({ commit }, id) {
        return new Promise((resolve, reject) => {
            preOrderAPI.resendToAX(warning => {
                resolve()
            }, id)
        })
    },

    resendPreOrderToAX({ commit }, id) {
        return new Promise((resolve, reject) => {
            preOrderAPI.resendPreOrderToAX(preOrder => {
                resolve()
            }, id)
        })
    }
}

// MUTATIONS
const mutations = {
    [types.SEND_NEW_PREORDER] (state, { newSheetId }) {},
    [types.RECEIVE_PREORDERS] (state, { order }) {
        state.PreOrders = order.PreOrders
        state.PreOrdersFilters = order.Filters
        state.PreOrdersPagination = {
            PageStartIndex: order.PageStartIndex,
            PageEndIndex: order.PageEndIndex,
            Pages: order.Pages,
            TotalCount: order.TotalCount,
            PageCount: order.PageCount
        }
    },
    [types.RECEIVE_CLOSED_PREORDERS] (state, { order }) {
        state.ClosedPreOrders = order.PreOrders
        state.PreOrdersFilters = order.Filters
        state.PreOrdersPagination = {
            PageStartIndex: order.PageStartIndex,
            PageEndIndex: order.PageEndIndex,
            Pages: order.Pages,
            TotalCount: order.TotalCount,
            PageCount: order.PageCount
        }
    },
    [types.RECEIVE_PREORDERS_FORECASTED] (state, { order }) {
        state.PreOrdersForecasted = order.PreOrders
        state.PreOrdersForecastedPagination = {
            PageStartIndex: order.PageStartIndex,
            PageEndIndex: order.PageEndIndex,
            Pages: order.Pages,
            TotalCount: order.TotalCount,
            PageCount: order.PageCount
        }
    },
    [types.RECEIVE_PREORDER_BY_ID] (state, { order }) {
        state.PreOrder = order
    },
    [types.RECEIVE_PREORDER_TOTALS_BY_ID] (state, { order }) {
      state.PreOrderTotals = order
    },
    [types.RECEIVE_PREORDER_NOTIFICATIONS_BY_ID] (state, { order }) {
      state.PreOrderNotifications = order
    },
    [types.RECEIVE_PREORDER_PRODUCTS_BY_ID] (state, { order }) {
        state.PreOrderProducts = order
    },
    [types.RECEIVE_PREORDER_MARKETING_PRODUCTS_BY_ID] (state, { order }) {
        state.PreOrderMarketingProducts = order
    },
    [types.UPDATE_PREORDER_BY_ID] (state, { order }) {},
    [types.CLOSE_PREORDER_BY_ID] (state, { order }) {},
    [types.SEND_CUSTOMERS] (state, { customers }) {
        state.Customers = customers.Customers
        state.CustomersFilters = customers.Filters
        state.CustomersPagination = {
            PageStartIndex: customers.PageStartIndex,
            PageEndIndex: customers.PageEndIndex,
            Pages: customers.Pages,
            TotalCount: customers.TotalCount,
            PageCount: customers.PageCount
        }
    },
    [types.RESET_CUSTOMERS] (state) {
        state.Customers = []
        state.CustomersPagination = {}
    },
    [types.RECEIVE_CUSTOMER_BY_ID] (state, { customer }) {
        state.Customer = customer;
    },
    [types.SEND_CUSTOMER_SEARCH] (state, { customers }) {
        state.CustomerOptions = customers
    },
    [types.SEND_CUSTOMER_USERS] (state, { customerUsers }) {
        state.CustomerUsersOptions = customerUsers
    },
    [types.SEND_CUSTOMER_ADDRESS] (state, { customerAddress }) {
        state.CustomerAddressOptions = customerAddress
    },
    [types.RECEIVE_PREORDER_SUBGROUP_TOTALS] (state, { totals }) {
        state.PreOrderSubGroupTotals = totals
    },
    [types.RECEIVE_PREORDER_DELIVERY_MOMENT_TOTALS] (state, { totals }) {
        state.PreOrderDeliveryMomentTotals = totals
    },
    [types.RECEIVE_PREORDER_TARGETS_AND_TOTALS] (state, { totals}) {
        state.PreOrderTargetsAndTotals = totals
    },
    [types.RESET_PREORDER] (state) {
        state.PreOrder = {}
    },
    [types.SEND_TO_SALES] (state) {},
    [types.RECEIVE_AX_WARNINGS] (state, { warnings }) {
        state.AXWarnings = warnings.AXWarnings
        state.AXWarningsPagination = {
            PageStartIndex: warnings.PageStartIndex,
            PageEndIndex: warnings.PageEndIndex,
            Pages: warnings.Pages,
            TotalCount: warnings.TotalCount,
            PageCount: warnings.PageCount
        }
    },
    [types.IGNORE_AX_WARNING] (state) {},
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/PreOrders.js